import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from "@mui/material";
import MaInput from "../../../../Components/UI/ma-input";
import MaButton from "../../../../Components/UI/ma-button";

export function CancelOrderDialog({ open, onClose, onConfirm, loading = false }) {
  const [reason, setReason] = useState("");
  const [comments, setComments] = useState("");
  const [error, setError] = useState("");

  const reset = () => {
    setReason("");
    setComments("");
    setError("");
  };

  const handleConfirm = async () => {
    if (!reason) {
      setError("Select a reason before cancelling this order.");
      return;
    }

    try {
      await onConfirm?.({ reason, comments });
      reset();
    } catch (err) {
      setError(err?.message ?? "Could not cancel order.");
    }
  };

  const handleKeep = () => {
    if (loading) return;
    reset();
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          maxWidth: 440,
          width: "100%",
        },
      }}
    >
      <DialogTitle className="pb-2 text-[17px] font-semibold text-[#18181B]">
        Cancel Order
      </DialogTitle>
      <DialogContent className="space-y-4 pt-2">
        <MaInput
          select
          fullWidth
          label="Select Reason"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            setError("");
          }}
          borderColor="#E5E7EB"
          disabled={loading}
        >
          <MenuItem value="">Choose reason</MenuItem>
          <MenuItem value="customer">Customer request</MenuItem>
          <MenuItem value="inventory">Out of stock</MenuItem>
          <MenuItem value="duplicate">Duplicate order</MenuItem>
          <MenuItem value="other">Other</MenuItem>
        </MaInput>
        <MaInput
          label="Additional comments (optional)"
          multiline
          minRows={3}
          fullWidth
          noHeight
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          borderColor="#E5E7EB"
          disabled={loading}
        />
        {error ? (
          <p className="my-0 text-[12px] font-medium text-[#DC2626]">
            {error}
          </p>
        ) : null}
      </DialogContent>
      <DialogActions className="flex-wrap gap-2 px-4 pb-4 pt-0 sm:justify-end">
      <MaButton
        
          title="Confirm Cancel"
          onClick={handleConfirm}
          loading={loading}
          disabled={loading || !reason}
          sx={{
            bgcolor: "#fff",
            minHeight: "44px",
            color:'#DC2626',
            border:'1px solid #EAEAEA80',
            px: 3,
            borderRadius: "12px",
          }}
        />
        <MaButton
          title="No, Keep Order"
          variant={"primary"}
          onClick={handleKeep}
          disabled={loading}
        
        />
       
      </DialogActions>
    </Dialog>
  );
}
